import axios from "../axiosConfig";

export interface StaffFreeSlotsParams {
  startDate?: string;
  endDate?: string;
  status?: string;
}

export async function getStaffFreeSlots(params: StaffFreeSlotsParams) {
  return axios.get("/staff-free-slots", {
    params: {
      startDate: params.startDate,
      endDate: params.endDate,
      status: params.status,
    },
  });
}

export async function getStaffFreeSlotById(id: string) {
  return axios.get(`/staff-free-slots/${id}`);
}

export interface CreateAppointmentPayload {
  slotId: string;
}

export interface CreateAppointmentPayload {
  slotId: string;
  title?: string;
  description?: string;
}

export async function createAppointment(payload: CreateAppointmentPayload) {
  return axios.post("/appointments", payload);
}

export interface GetAppointmentsParams {
  staffId?: string;
  startDate?: string;
  endDate?: string;
  status?: "pending" | "approved" | "declined" | "canceled";
}

export async function getAppointments(params: GetAppointmentsParams) {
  return axios.get("/appointments", {
    params,
  });
}

export async function getAppointmentById(id: string) {
  return axios.get(`/appointments/${id}`);
}

export async function createRoomCodeForAppointment(id: string) {
  return axios.post(`/appointments/${id}/room-code`);
}

export async function cancelAppointment(id: string) {
  return axios.patch(`/appointments/${id}/cancel`);
}
